import { render, staticRenderFns } from "./Subsidiaries.vue?vue&type=template&id=483f9790&scoped=true"
import script from "./Subsidiaries.vue?vue&type=script&lang=js"
export * from "./Subsidiaries.vue?vue&type=script&lang=js"
import style0 from "./Subsidiaries.vue?vue&type=style&index=0&id=483f9790&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483f9790",
  null
  
)

export default component.exports